import React, { useEffect, useState } from "react";
import axios from "axios";
import styles from "../../assets/styles/onlineyogacourse/Onlineyoga.module.css";
import { useNavigate } from "react-router-dom";
import BooksSection from "components/MyBooks/Bookssection";

const API_BASE = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000";
const API = `${API_BASE}/api/online-yoga`;

const DEFAULT_CONTENT = {
  heroEyebrow: "Transform Your Life",
  heroTitle: "Best Online Yoga Classes",
  heroSubtitle:
    "Yoga is commonly believed to be a physical practice, but it is a much deeper discipline that can dramatically improve the quality of life.",
  heroDescription:
    "If you have a casual interest in yoga, or are considering pursuing a career as a yoga teacher, this course is meant for you.",
  heroButtonText: "Start Your Journey",
  heroButtonLink: "/BookingForm",
  heroBackgroundImage:
    "",
  classSectionHeading: "Choose Your Class and Slot",
  classes: [
    {
      title: "Stress Management Yoga",
      time: "6PM - 7PM",
      price: "399",
      image:
        "",
    },
    {
      title: "Family Yoga",
      time: "8AM - 9AM",
      price: "1299",
      image:
        "",
    },
    {
      title: "Beginners Yoga",
      time: "6AM - 7AM",
      price: "399",
      image:
        "",
    },
    {
      title: "Yoga after 60s",
      time: "7AM - 8AM",
      price: "399",
      image:
        "",
    },
  ],
  benefitsImage:
    "",
  benefitsHeading: "Benefits Of Yoga from Hatha Yogashram",
  benefits: [
    { text: "RYT and certified yoga instructors with years of experience" },
    { text: "Ayurveda and Indian cooking support classes" },
    { text: "Fun with yoga and practical daily guidance" },
    { text: "24x7 support and community connection" },
    { text: "Pleasant accommodation and retreat energy" },
    { text: "Weekly excursions and immersive learning" },
  ],
  finalCtaTitle:
    "Embark Your Yogic Journey with Yoga Alliance Certified Yoga Teacher Training School in Rishikesh, India",
  finalCtaButtonText: "Book Now",
  finalCtaButtonLink: "/BookingForm",
};

const resolveImageSrc = (image) => {
  if (!image) return "";
  if (/^https?:\/\//.test(image)) return image;
  if (image.startsWith("/uploads/")) return `${API_BASE}${image}`;
  return `${API_BASE}/uploads/${image}`;
};

const mergeContent = (incoming) => ({
  ...DEFAULT_CONTENT,
  ...incoming,
  classes:
    Array.isArray(incoming?.classes) && incoming.classes.length
      ? incoming.classes
      : DEFAULT_CONTENT.classes,
  benefits:
    Array.isArray(incoming?.benefits) && incoming.benefits.length
      ? incoming.benefits
      : DEFAULT_CONTENT.benefits,
});

const OnlineYoga = () => {
  const navigate = useNavigate();
  const [content, setContent] = useState(DEFAULT_CONTENT);

  useEffect(() => {
    const fetchContent = async () => {
      try {
        const res = await axios.get(API);
        const latest = Array.isArray(res.data?.data) ? res.data.data[0] : null;

        if (latest) {
          setContent(mergeContent(latest));
        }
      } catch (error) {
        console.error("Online Yoga fetch error:", error.response?.data || error.message);
      }
    };

    fetchContent();
  }, []);

  const navigateTo = (link) => {
    if (!link) return;
    if (/^https?:\/\//.test(link)) {
      window.location.href = link;
      return;
    }
    navigate(link);
  };

  return (
    <div className={styles.container}>
      <svg
        className={styles.omDecor1}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 20 Q130 40 140 70 Q150 100 140 130 Q130 160 100 180 Q70 160 60 130 Q50 100 60 70 Q70 40 100 20 M80 60 Q90 70 100 70 Q110 70 120 60 M85 90 Q92 100 100 105 Q108 100 115 90 M75 120 Q85 135 100 140 Q115 135 125 120"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
        />
      </svg>

      <section className={styles.heroBanner}>
        <div className={styles.heroBackground}>
          <img
            src={resolveImageSrc(content.heroBackgroundImage)}
            alt={content.heroTitle}
            className={styles.heroImage}
          />
          <div className={styles.heroOverlay}></div>
        </div>

        <div className={styles.heroContent}>
          <div className={styles.omSymbol}>
            <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M50 10 Q65 20 70 35 Q75 50 70 65 Q65 80 50 90 Q35 80 30 65 Q25 50 30 35 Q35 20 50 10 M40 30 Q45 35 50 35 Q55 35 60 30 M42.5 45 Q46 50 50 52.5 Q54 50 57.5 45 M37.5 60 Q42.5 67.5 50 70 Q57.5 67.5 62.5 60"
                fill="none"
                stroke="currentColor"
                strokeWidth="2.5"
              />
            </svg>
          </div>

          <p className={styles.welcomeText}>{content.heroEyebrow}</p>
          <h1 className={styles.heroTitle}>{content.heroTitle}</h1>
          <p className={styles.heroSubtitle}>{content.heroSubtitle}</p>
          {content.heroDescription && (
            <p className={styles.heroSubtitle}>{content.heroDescription}</p>
          )}
          <button
            className={styles.ctaButton}
            onClick={() => navigateTo(content.heroButtonLink)}
          >
            <span>{content.heroButtonText || "Start Your Journey"}</span>
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M5 12h14M12 5l7 7-7 7" />
            </svg>
          </button>
        </div>

        <svg
          className={styles.lotusDecor}
          viewBox="0 0 150 150"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g stroke="currentColor" strokeWidth="2" fill="none">
            <path d="M75 120 Q65 90 65 60 Q65 45 75 30" />
            <path d="M75 120 Q85 90 85 60 Q85 45 75 30" />
            <path d="M45 105 Q52.5 90 60 75" />
            <path d="M105 105 Q97.5 90 90 75" />
            <circle cx="75" cy="52.5" r="12" />
            <path d="M30 112.5 Q45 97.5 60 90" />
            <path d="M120 112.5 Q105 97.5 90 90" />
          </g>
        </svg>
      </section>

      <section className={styles.classesSection}>
        <div className={styles.sectionDivider}>
          <svg
            className={styles.yogaIcon}
            viewBox="0 0 50 50"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="25" cy="15" r="5" fill="currentColor" />
            <path
              d="M15 25 L25 20 L35 25 M25 20 L25 35 M20 35 L25 35 L30 35"
              stroke="currentColor"
              strokeWidth="2"
              fill="none"
            />
          </svg>
        </div>

        <div className={styles.sectionHeader}>
          <h2 className={styles.sectionTitle}>{content.classSectionHeading}</h2>
        </div>

        <div className={styles.classesGrid}>
          {content.classes.map((yogaClass, index) => (
            <div key={`${yogaClass.title}-${index}`} className={styles.classCard}>
              <div className={styles.classImageWrapper}>
                <img
                  src={resolveImageSrc(yogaClass.image)}
                  alt={yogaClass.title}
                  className={styles.classImage}
                />
              </div>
              <div className={styles.classContent}>
                <h3 className={styles.classTitle}>{yogaClass.title}</h3>
                <p className={styles.classTime}>{yogaClass.time}</p>
                <p className={styles.classPrice}>Starting @{yogaClass.price}</p>
                <button
                  className={styles.bookButton}
                  onClick={() => navigateTo(content.heroButtonLink)}
                >
                  Book Now
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.mandalaLeft}>
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.1" stroke="currentColor" strokeWidth="1" fill="none">
              <circle cx="100" cy="100" r="80" />
              <circle cx="100" cy="100" r="60" />
              <circle cx="100" cy="100" r="40" />
              <circle cx="100" cy="100" r="20" />
              {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, currentIndex) => (
                <line
                  key={currentIndex}
                  x1="100"
                  y1="100"
                  x2={100 + 80 * Math.cos((angle * Math.PI) / 180)}
                  y2={100 + 80 * Math.sin((angle * Math.PI) / 180)}
                />
              ))}
            </g>
          </svg>
        </div>
      </section>

      <section className={styles.benefitsSection}>
        <div className={styles.benefitsContainer}>
          <div className={styles.benefitsImage}>
            <img
              src={resolveImageSrc(content.benefitsImage)}
              alt={content.benefitsHeading}
              className={styles.benefitsImg}
            />
            <div className={styles.imageFrame}></div>
          </div>

          <div className={styles.benefitsContent}>
            <div className={styles.sectionDivider}>
              <svg
                className={styles.yogaIcon}
                viewBox="0 0 50 50"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="25" cy="15" r="5" fill="currentColor" />
                <path
                  d="M15 25 L25 20 L35 25 M25 20 L25 35 M20 35 L25 35 L30 35"
                  stroke="currentColor"
                  strokeWidth="2"
                  fill="none"
                />
              </svg>
            </div>

            <h2 className={styles.benefitsTitle}>{content.benefitsHeading}</h2>

            <div className={styles.benefitsList}>
              {content.benefits.map((benefit, index) => (
                <div key={`${benefit.text}-${index}`} className={styles.benefitItem}>
                  <svg
                    className={styles.checkIcon}
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                  >
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                  <span>{benefit.text}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.mandalaRight}>
          <svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <g opacity="0.1" stroke="currentColor" strokeWidth="1" fill="none">
              <circle cx="100" cy="100" r="80" />
              <circle cx="100" cy="100" r="60" />
              <circle cx="100" cy="100" r="40" />
              <circle cx="100" cy="100" r="20" />
              {[0, 45, 90, 135, 180, 225, 270, 315].map((angle, currentIndex) => (
                <line
                  key={currentIndex}
                  x1="100"
                  y1="100"
                  x2={100 + 80 * Math.cos((angle * Math.PI) / 180)}
                  y2={100 + 80 * Math.sin((angle * Math.PI) / 180)}
                />
              ))}
            </g>
          </svg>
        </div>
      </section>

      <BooksSection />

      <section className={styles.finalCta}>
        <div className={styles.ctaContent}>
          <svg
            className={styles.ctaOm}
            viewBox="0 0 120 120"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M60 12 Q78 24 84 42 Q90 60 84 78 Q78 96 60 108 Q42 96 36 78 Q30 60 36 42 Q42 24 60 12 M48 36 Q54 42 60 42 Q66 42 72 36 M51 54 Q55.2 60 60 63 Q64.8 60 69 54 M45 72 Q51 81 60 84 Q69 81 75 72"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
            />
          </svg>

          <h2 className={styles.ctaTitle}>{content.finalCtaTitle}</h2>
          <button
            className={styles.ctaMainButton}
            onClick={() => navigateTo(content.finalCtaButtonLink)}
          >
            {content.finalCtaButtonText || "Book Now"}
          </button>
        </div>
      </section>

      <svg
        className={styles.omDecor2}
        viewBox="0 0 200 200"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 20 Q130 40 140 70 Q150 100 140 130 Q130 160 100 180 Q70 160 60 130 Q50 100 60 70 Q70 40 100 20 M80 60 Q90 70 100 70 Q110 70 120 60 M85 90 Q92 100 100 105 Q108 100 115 90 M75 120 Q85 135 100 140 Q115 135 125 120"
          stroke="currentColor"
          strokeWidth="2"
          fill="none"
          opacity="0.1"
        />
      </svg>
    </div>
  );
};

export default OnlineYoga;
